import { createFileRoute } from '@tanstack/react-router';

import { OnboardPage } from '../login/pages/OnboardPage';

export const Route = createFileRoute('/onboard/$userId/$token')({
    component: OnboardPage,
});
